import clsx from "clsx";
import PreviewButton from "../components/PreviewButton";
import { Answer } from "../preViewQuiz";
import { ReactNode } from "react";

type ChildIdentificationAnswersProps = {
  answers: Answer[];
  enabledButtons: boolean;
  selectedAnswerId: number | null;
  handleAnswerClick: (answerId: number) => void;
  children?: ReactNode;
};

const ChildIdentificationAnswers = ({
  answers,
  enabledButtons,
  selectedAnswerId,
  handleAnswerClick,
  children
}: ChildIdentificationAnswersProps) => {
  return (
    <div className={"container-answers-hc"}>
      {answers.map((answer, index) => (
        <>
          {index === 2 && children && <div>{children}</div>}

          <div key={answer.quizQuestionAnswerId} className="answer-item-hc">
            <PreviewButton
              onClick={() => handleAnswerClick(answer.answerId)}
              disabled={!enabledButtons}
              className={clsx("btn-answers-hc", {
                "btn-red-answer-selected": selectedAnswerId === answer.answerId
              })}
              style={{
                backgroundImage: answer.answer.files?.[0]?.tempUri
                  ? `url(${answer.answer.files[0].tempUri})`
                  : "none"
              }}
              label={answer.answer.label}
            />
          </div>
        </>
      ))}
    </div>
  );
};

export default ChildIdentificationAnswers;
